import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { Card, CardContent } from "@material-ui/core";

const SubheadingSkeleton = () => (
  <div data-testid="stepresult-subheading">
    <h6  className="stepresult-subheading">
      <Skeleton variant="text" width={350} height={20} />
    </h6>
    <Skeleton variant="rect" height={20} />
  </div>
);

const CardSkeleton = () => (
  <div data-testid="stepresult-section-card" className="stepresult-section-card">
    <Card>
      <CardContent>
        <div className="stepresult-section-heading">
          <Skeleton variant="rect" height={40} />
        </div>
        <SubheadingSkeleton />
        <SubheadingSkeleton />
        <SubheadingSkeleton />
        <SubheadingSkeleton />
      </CardContent>
    </Card>
  </div>
);

const ProgressStepSkeleton = () => {
  return (
    <div data-testid="stepresult" className="stepresult">
      <div className="stepresult-userdetails">
        <div className="stepresult-userdetails-heading">
          <Skeleton variant="text"  height={50} />
        </div>
        <div className="stepresult-userdetails-text">
          <Skeleton variant="text"  height={30} />
        </div>
        <div className="stepresult-userdetails-text">
          <Skeleton variant="text" height={20} />{" "}
        </div>
      </div>
      <div className="stepresult-testdetails">
        <div className="stepresult-testdetails-block">
          <Skeleton variant="rect" width={300} height={20} />
        </div>
        <div className="stepresult-testdetails-block">
          <Skeleton variant="rect" width={300} height={20} />
        </div>
      </div>
      <div className="stepresult-levelinfo">
        <Skeleton variant="text"  height={20} />
      </div>
      <div className="stepresult-levelnote">
        <Skeleton variant="text" width={300}  height={20} />
      </div>

      <div className="stepresult-card">
        <Card>
          <CardContent>
            <div className="stepresult-section-heading">
              <Skeleton variant="rect" height={40} />
            </div>
            <SubheadingSkeleton />
            <SubheadingSkeleton />
            <SubheadingSkeleton />
            <SubheadingSkeleton />
          </CardContent>
        </Card>
      </div>
      <div className="stepresult-section">
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </div>
    </div>
  );
};

export default ProgressStepSkeleton;
